export const closeUnlessEscape = (onClose: () => void) => (_event: object, reason: string) => {
  if (reason !== 'escapeKeyDown') {
    onClose();
  }
};
